import { render } from "./VersionList.vue?vue&type=template&id=4dc0818d&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"

import "./VersionList.vue?vue&type=style&index=0&id=4dc0818d&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4dc0818d"

export default script